import React from "react";

const Client = (props) => {
  const { Image, Alt } = props;

  return (
    <div className="">
      <img src={Image} className="img-fluid mx-auto" alt={Alt} />
    </div>
  );
};

export default Client;
